<template>
  <div>
    <SettingGroup title="">
      <SettingItem label="キャリア表示">
        <ToggleSwitch
          v-model="form.toggle.mobileCarrierDisplay"
          :disable="false"
        />
      </SettingItem>
      <SettingItem label="緊急速報">
        <ToggleSwitch
          v-model="form.toggle.criticalAlerts"
          :disable="false"
        />
      </SettingItem>
    </SettingGroup>
  </div>
</template>

<script>
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'
import { mapStores } from 'pinia'

export default {
  name: 'NetworkLTEVue2',
  components: { ToggleSwitch, SettingGroup, SettingItem },
  data () {
    return {
      form: {
        toggle: {
          mobileCarrierDisplay: false,
          criticalAlerts: false,
        },
      },
      // ストアの一時設定
      setting: null,
    }
  },
  computed: {
    ...mapStores(useRadioSettingsStore),
  },
  created () {
    // ストアから設定取得
    this.setting = this.radioSettingsStore.getTempSetting()

    // 設定 → フォーム
    this.transSetting2Form()

    // フォーム変更を監視：設定へ反映 & 保存
    this.$watch('form', () => {
      this.transForm2Setting()
      this.radioSettingsStore.saveTempSetting(this.setting)
    }, { deep: true })
  },
  methods: {
    // 設定 ← フォーム
    transForm2Setting () {
      const data = this.setting?.Network?.LTE
      if (!data) return

      data.MobileCarrierDisplay = this.form.toggle.mobileCarrierDisplay
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      data.CriticalAlerts = this.form.toggle.criticalAlerts
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
    },

    // 設定 → フォーム
    transSetting2Form () {
      const data = this.setting?.Network?.LTE
      if (!data) return

      this.form.toggle.mobileCarrierDisplay = data.MobileCarrierDisplay === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.criticalAlerts      = data.CriticalAlerts      === BC.COMMON.TOGGLE.ENABLE
    },
  },
}
</script>
